import { Info24px, SecureShield } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Text, Flex } from "@similarweb/ui-components/foundations";

import { getTermsOfUseHref } from "app/common/hrefs";
import {
    NoTouchPurchaseSummaryModalDetailsInfo,
    StyledLink,
} from "app/components/no-touch-purchase-modal/summary-modal/details/StyledNoTouchPurchaseSummaryModalDetails";
import type { INoTouchAddon } from "app/components/no-touch-purchase-modal/summary-modal/useNoTouchPurchaseSummaryModal";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";
import { translate } from "app/filters/i18nFilter";

interface IFooterProps {
    isLoading: boolean;
    selectedAddon?: INoTouchAddon;
    onPurchaseClick: () => void;
}

export const Footer = ({ isLoading, selectedAddon, onPurchaseClick }: IFooterProps) => {
    return (
        <Flex
            flexDirection="column"
            gap="24px"
        >
            <Button
                type="primary"
                isDisabled={!selectedAddon || isLoading}
                onClick={onPurchaseClick}
                width={"100%"}
                data-automation="no-touch-purchase-summary-footer-purchase-button"
            >
                {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.buttonText)}
            </Button>

            <NoTouchPurchaseSummaryModalDetailsInfo>
                <Flex>
                    <Info24px size="sm" />
                </Flex>
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon[400]}
                >
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.info)}
                </Text>
            </NoTouchPurchaseSummaryModalDetailsInfo>

            <Flex
                flexDirection="column"
                gap="8px"
                width={"100%"}
            >
                <Flex
                    gap="10px"
                    justifyContent="center"
                    alignItems="center"
                >
                    <SecureShield
                        size="sm"
                        color={colorsPalettes.mint[400]}
                    />
                    <Text fontVariant="body2">
                        {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.safePayment)}
                    </Text>
                </Flex>
                <Text
                    fontVariant="caption"
                    textAlign="center"
                >
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.youAccept)}{" "}
                    <span data-automation="no-touch-purchase-summary-footer-tos-link">
                        <StyledLink
                            label={translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.tos)}
                            url={getTermsOfUseHref()}
                        />
                    </span>
                </Text>
            </Flex>
        </Flex>
    );
};
